import { combineReducers } from 'redux';

import list from './list';
import selected from './selected';
import listByUser from './listByUser';
import defaultOptions from './defaultOptions';

export default combineReducers({
  list,
  selected,
  listByUser,
  defaultOptions,
});
